import React, {Component, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {getUserDetails} from "../RequestManager";
import {socket} from "../components/Socket";
import {
    Badge,
    Divider,
    Grid,
    Group,
    Header,
    Image,
    Anchor,
    Loader,
    Button,
    Paper,
    Select,
    Text,
    MultiSelect, Stack, SegmentedControl, Modal, Alert, TextInput, NumberInput
} from "@mantine/core";
import {Defaults} from "../Constants/Constants";
import {Colors} from "../Constants/Colors";
import CustomToast from "../components/CustomToast";
import BookView from "../components/BookView";
import moment from "moment";
import CustomHeader from "../components/CustomHeader";
import {EmailOutlined} from "@mui/icons-material";
class Dashboard extends Component{
    constructor(props) {
        super(props);
        this.state={
            details: undefined,
            bonuses: [],
            timings: [],
            isLoading: true,
            read365Plans:[],
            lifeGrowthPlans:[],
            name:"",
            whatsapp:"",
            count: 1,
            gift: 0
        }
    }
    componentDidMount() {
        this.getDetails();
        socket.on('success',this.handleSuccess);
        socket.on('failure',this.handleFailure);
    }
    componentWillUnmount() {
        socket.off('success');
        socket.off('failure');
    }
    getDetails = () =>{
        this.setState({isLoading: true});
        socket.emit('UserProfile',{mobile: this.props.mobile});
        socket.emit('defaultTimings',{});
        socket.emit('bonusList',{});
    }
    handleSuccess = (data) =>{
        console.log(data);
        switch(data?.type){
            case 'UserProfile':
                const {bundlePlans,lgPlans,plans,gift} = data?.details || {bundlePlans: 0,coachingPlans: 0};
                if (bundlePlans > 0) {
                    this.props.navigation('/choose-plan', {state: {id: "Read365Books"}});
                }else if(lgPlans > 0){
                    this.props.navigation('/choose-plan', {state: {id: "LifeGrowth365"}});
                }else{
                    const read365Plans = plans?.filter(a => a.type === 'Read365Books');
                    const lifeGrowthPlans = plans?.filter(a => a.type === 'LifeGrowth365');
                    this.setState({details:data?.details,read365Plans,lifeGrowthPlans,gift,isLoading: false});
                }
                break;
            case 'UpdateUser':
                this.setState({alert: {message: 'Updated Successfully',action: 'success'}});
                setTimeout(() => this.setState({alert: undefined}), 5000);
                this.getDetails();
                break;
            case 'defaultTimings':
                this.setState({timings: data?.timings});
                break;
            case 'bonusList':
                this.setState({bonuses: data?.bonusList});
                break;
            case 'UpdatePrefrences':
                this.setState({alert: {message: 'Updated Successfully',action: 'success'}});
                this.getDetails();
                break;
            case 'SendGiftToUser':
                this.setState({alert: {message: data?.message,action: 'success'}});
                this.hideGiftModal();
                this.getDetails();
                break;
        }
    }
    handleFailure = (data) =>{
        switch(data?.type){
            case 'UserProfile':
                this.setState({details:data?.details});
                break;
            case 'SendGiftToUser':
                this.setState({isGiftLoading: false,error: data?.message});
                break;
        }
    }
    hideSnackbar = () =>{
        this.setState({alert: undefined});
    }
    handleUpdate = () =>{
        window.open('https://read365books.com/read-books');
    }
    showGiftModal = () => this.setState({showGiftModal: true});
    hideGiftModal = () => this.setState({showGiftModal: false, error: undefined,isGiftLoading: false,name: '',whatsapp: '',count:1});
    sendGift = () =>{
        const {name,whatsapp,count} = this.state;
        this.setState({isGiftLoading: true});
        socket.emit("SendGiftToUser",{userMobile: this.props.mobile ,name,whatsapp,count})

    }
    render() {
        const {details,isLoading,showGiftModal,timings,isGiftLoading,error,alert,read365Plans,lifeGrowthPlans,gift,name,whatsapp,count} = this.state;
        const remaining = details?.totalDays - details?.day;
        return <div>
            <CustomHeader />
            <div style={{marginTop: 60}}>
                {remaining < 10 && <Alert title={'Subscription Ending Soon'} color={'red'} mb={5} m={5} p={5} sx={{gap: 3}}>
                    <Group>
                        {details.status != 4 ? <Text>You're subscription going to end in {remaining != 0 ? `${remaining} Days` : `Today`}. Please Update to Continue Reading</Text>:
                        <Text>You're subscription Ended. Please Update to Continue Reading</Text>}
                        <Button variant={'outline'} size={'xs'} onClick={this.handleUpdate}>Update Plan</Button>
                    </Group>
                </Alert>}
            {isLoading ? <Group position={'center'}><Loader color={'#075E54'}/></Group> : <div>
                {alert && <CustomToast alert={alert} onHide={this.hideSnackbar} />}
                <Paper shadow={'md'} p={'xs'}>
                    <Group position={'apart'}>
                        <Text>{details?.name}</Text>
                        {/*<Badge color={'green'} size={'sm'} m={1} px={10}>Day {details?.day} / {details?.totalDays}</Badge>*/}
                    </Group>
                    <Group position={'apart'}>
                        <Text size={'sm'} color={'dimmed'}>{details?.mobile}</Text>
                        <Text size={'sm'} color={'dimmed'}>{details?.email}</Text>
                    </Group>
                </Paper>
                <Button my={5} onClick={()=> this.props.navigation('/assignments')}>Assignments</Button>
                {/*{gift > 0 ? <Paper shadow={'md'} my={5}>*/}
                {/*   <Group position={'apart'} mx={10}>*/}
                {/*       <Text>You've <b>{gift} Gifts.</b> You can now 🎁GIFT🎁 our products to your "Friends & Families" members*/}
                {/*            & Surprise them..!!</Text>*/}
                {/*        <Button variant={'outline'} m={5} onClick={this.showGiftModal}>Send Gift</Button>*/}
                {/*   </Group>*/}
                {/*</Paper>: <Group>*/}
                {/*    <Image*/}
                {/*        src={'https://wacoach.s3.ap-south-1.amazonaws.com/rx0ViitjSPG3/7xogl/h3zjzk2bb891671766903361Buy & send surprise gift to your friends & Family members.png'}*/}
                {/*        height={100}*/}
                {/*        fit={'contain'}*/}
                {/*    />*/}
                {/*</Group>}*/}
                <Modal opened={showGiftModal} title={"Send Gift to Friends / Family"} onClose={this.hideGiftModal}>
                    <TextInput mt={5} label={'Name'} value={name} onChange={(e) => this.setState({name: e.target.value})} />
                    <TextInput  mt={5} label={'Whatsapp Number'} value={whatsapp} onChange={(e) => this.setState({whatsapp: e.target.value})} />
                    <NumberInput  mt={5} label={'Gift Count'} value={count}  max={gift} min={1} onChange={(count) => this.setState({count})} />
                    {error && <Text color={'red'} my={5}>{error}</Text>}
                    <Group m={10} position={'center'}>
                        <Button variant={'outline'} loading={isGiftLoading} onClick={this.sendGift} disabled={name.trim() === '' || whatsapp.trim() === "" || count < 1}>Send Gift</Button>
                    </Group>
                </Modal>
                {read365Plans?.length > 0 &&<>
                    <Divider labelPosition={'center'} label={<Text size={'xl'} align={'center'} weight={'bold'} color={Colors.Primary}>Read365Books</Text>} mt={20} />
                    <Grid mt={3}>
                        {read365Plans?.map(a => <PlanDetails details={a} mobile={details?.mobile} timings={timings}/>)}
                    </Grid>
                </>}
                {lifeGrowthPlans?.length > 0 &&<>
                    <Divider labelPosition={'center'} label={<Text size={'xl'} align={'center'} weight={'bold'} color={Colors.Primary}>LifeGrowth365</Text>} mt={20} />
                    <Grid mt={10}>
                        {lifeGrowthPlans?.map(a => <PlanDetails details={a} mobile={details?.mobile} timings={timings}/>)}
                    </Grid>
                </>}
                <Divider labelPosition={'center'} label={<Text size={'xl'} align={'center'} weight={'bold'} color={Colors.Primary}>Support</Text>} mt={20} />
                <Grid mt={20}>
                    <Grid.Col span={12} lg={6} xl={6} py={1}>
                        <Paper shadow={'md'} p={2} px={10} py={2}>
                            <Stack sx={{gap: 5}}>
                                <Group position={'apart'}>
                                    <Text weight={'bold'} size={'sm'} color={Colors.Primary}>Support</Text>
                                    <Group position={'left'} sx={{gap: 3}}>
                                        <EmailOutlined fontSize={'small'} />
                                        <Text color={'dimmed'}>support@read365books.com</Text>
                                    </Group>
                                </Group>
                                <Text size={'sm'}>Type & Send any of these keywords for instant support via whatsapp <b>"Support (or) Help (or) FAQ (or) Query (or) Clarification (or) Doubt"</b></Text>
                            </Stack>
                        </Paper>
                    </Grid.Col>
                </Grid>
            </div>}
            </div>
        </div>
    }
}
export default function(props){
    const navigation = useNavigate();
    const {state} = useLocation();
    const user = getUserDetails();
    return <Dashboard {...props} params={state} navigation={navigation} mobile={user?.mobile} user={user}  />
};
const PlanDetails = ({details,timings,mobile}) =>{
    const [isEdit,setEdit] = useState(false);
    const [show,setShow] = useState(false);
    const navigation = useNavigate();
    const statusChange = (value) =>{
        if(value === '3' && details?.status === 1){
            socket.emit('UpdateUser', {type: 'pause',productId:details?.productId,mobile});
        }else if(value  === '1'&& details?.status === 3){
            socket.emit('UpdateUser', {type: 'resume',productId:details?.productId,mobile});
        }
    }
    const isWati = ['Daily1Book','Weekly1Book',"Gita","Moti","Spirit","CEO"].includes(details?.productId);
    return <Grid.Col span={12} lg={6} xl={6} py={2}>
        {isEdit && <EditPrefrences details={details} timings={timings} mobile={mobile} onHide={() => setEdit(false)} />}
        <Paper shadow={'md'} p={2} px={10}>
            <Group position={'apart'}>
                <Group>
                    <Text weight={'bold'} size={'sm'} color={Colors.Primary}>{details?.name}</Text>
                    {isWati && <Badge size={'sm'}>Day {details?.day} / {details?.totalDays} </Badge>}
                </Group>
                {isWati && [1,3].includes(details?.status) && <SegmentedControl size={'xs'} onChange={() => setShow(true)} color={details?.status === 1 ?'green':'red'} data={[{value: '1',label: details?.status === 1? 'Active': 'Resume'},{value: '3',label: 'Pause'}]} my={10} value={details?.status?.toString()} />}
            </Group>
            <Modal opened={show} onClose={() => setShow(false)}  title="Change Status">
                {details?.status === 1 && <Text>It will Stop Sending Messages & Update Days For Members.Are you Sure want to Pause ?</Text>}
                {details?.status === 1 &&<Text>It will Start Sending Messages From Tomorrow. Are you sure want to Resume ?</Text>}
                <Group mt={10} position={'right'}><Button mt={5}  onClick={() => statusChange(details?.status === 1 ? '2': '1')}>{details?.status === 1 ? 'Pause': 'Resume'}</Button></Group>
            </Modal>
            {isWati && <Group my={3} position={'apart'}>
                <Badge size={'sm'} color={details?.userStatus?.color}>{details?.userStatus?.name}</Badge>
                {details?.language && <Badge size={'sm'} color={'violet'}>{details?.language}</Badge>}
                {details?.daysPerWeek && <Text my={5}>{['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((a, index) => {
                    const check = details?.daysPerWeek?.includes(index);
                    return <Badge
                        color={check ? 'green' : 'red'}
                        p={5}
                        size={'md'} mx={5}>{a}</Badge>
                })}</Text>}
                {details?.partsPerDay && <Text color={'dimmed'} size={'md'}>{details?.partsPerDay || 15} parts per day </Text>}
            </Group>}
            {details?.bookDetails &&  <Group sx={{borderWidth: 1,borderStyle: 'solid',borderColor:'lightgray',borderRadius: 10,padding: 5}}>
                {details?.bookDetails?.image && <Image src={details?.bookDetails?.image} fit={'cover'}  height={60} width={60} p={2} radius={10} alt="img"/>}
                <Stack spacing={2}  sx={{flex: 1, flexDirection:'column'}}>
                    <Text size='md' weight={500} style={{color:'steelblue'}} align={'left'}>{details?.bookDetails?.title}</Text>
                    <Text size='sm' color={'dimmed'} align={'left'}>By {details?.bookDetails?.author}</Text>
                </Stack>
            </Group>}
            {['Daily1Book','Weekly1Book'].includes(details?.productId) && details?.status > 0 && <Group position={'apart'} mt={10}>
                {details?.status === 1 && <Anchor size={'sm'} color={'blue'}
                                                  onClick={() => navigation('/plan', {state: {productId: details?.productId,productName: details?.name}})}>View
                    Plan Details</Anchor>}
                <Button size={'xs'} color={'blue'} onClick={() => setEdit(true)}>Edit</Button>
            </Group>}
        </Paper>
    </Grid.Col>
}
const EditPrefrences = ({details,timings,mobile,onHide}) =>{
    const [parts,setParts] = useState(details?.partsPerDay || 15);
    const [time,setTime] = useState(details?.time || []);
    const [lang,setLang] = useState(details?.lang || 'en');
    const timeArray = ['4:00 AM',
        '4:30 AM',
        '5:00 AM',
        '5:30 AM',
        '6:00 AM',
        '6:30 AM',
        '7:00 AM',
        '7:30 AM',
        '8:00 AM',
        '8:30 AM',
        '9:00 AM',
        '9:30 AM',
        '10:00 AM',
        '10:30 AM',
        '11:00 AM',
        '11:30 AM',
        '12:00 PM',
        '12:30 PM',
        '1:00 PM',
        '1:30 PM',
        '2:00 PM',
        '2:30 PM',
        '3:00 PM',
        '3:30 PM',
        '4:00 PM',
        '4:30 PM',
        '5:00 PM',
        '5:30 PM',
        '6:00 PM',
        '6:30 PM',
        '7:00 PM',
        '7:30 PM',
        '8:00 PM',
        // '8:30 PM',
        // '9:00 PM',
        // '9:30 PM',
        // '10:00 PM',
        // '10:30 PM',
        // '11:00 PM',
        // '11:30 PM'
    ];
    const [data,setData] = useState(details?.daysPerWeek || []);
    const [isError,setError] = useState(false);
    const [isLoading,setLoading] = useState(false);

    const changeParts = (count) =>{
        setParts(parseInt(count,10));
        setTime(timings[count]);
    }
    const handleTime = (t) =>{
        let timeSelected = t.map(a =>{
            return {time: a, displayTime: moment(a ,'LT').unix()}
        }).sort((a,b) => {
            if (a.displayTime < b.displayTime) return -1;
            if (a.displayTime > b.displayTime) return 1;
            return 0;
        }).map(a => a.time);
        setTime(timeSelected);
    }

    const onChange = (index) =>{
        if(data.includes(index)) {
            setData(data.filter(a => a != index));
        }else{
            let d = [...data,index].sort();
            setData(d);
        }
    }
    const handleSubmit = () =>{
        if(data.length > 3 && time.length === parts){
            setError(false);
            setLoading(true);
            socket.emit("UpdatePrefrences",{lang,time,partsPerDay: parts,daysPerWeek: data,mobile,productId: details?.productId});

        }else{
            setError(true);
        }
    }
    return <Modal opened={true}  title={<Text weight={'bold'}>Edit Prefrences - {details?.name}</Text>} size={'90%'}>
        <Grid>
            <Grid.Col span={6}>
                <Stack position={'apart'} mt={5} sx={{gap: 3}}>
                    <Text weight={'bold'} size={'sm'} color={Colors.Primary}>Days Per Week
                        <Text color={'dimmed'} size={'xs'}>{"Select Days You want to Receive Messages (Atleast 3)"}</Text>
                    </Text>
                    <Text my={5}>{['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((a, index) =>{
                        const check  =  data?.includes(index);
                        return <Badge
                            onClick={() => onChange(index)}
                            color={check? 'green':'red'}
                            p={5}
                            size={'md'} mx={5}>{a}</Badge>
                    })}</Text>
                    {isError && data.length < 3 && <Text color={'red'}>Atleast 3 Days Need to Select</Text>}
                </Stack>
            </Grid.Col>
            <Grid.Col span={6}>
                <Select
                    label={<Text weight={'bold'}>Change Language</Text>}
                    data={[{label: 'English',value:'en'},{label: 'Hindi',value:'hin'}]}
                    value={lang}
                    onChange={setLang}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <Select
                    label={<Text weight={'bold'}>No. of parts to receive</Text>}
                    data={Object.keys(timings).filter(a => details?.productId === 'Weekly1Book' ? parseInt(a,10) <= 7 : true).map(a => ({label: a,value:a}))}
                    value={parts.toString()}
                    onChange={changeParts} />
            </Grid.Col>
            <Grid.Col span={6}>
                <MultiSelect
                    label={<Text weight={'bold'}>{`Choose Timings (${parts})`}</Text>}
                    data={timeArray.map(a => ({label: a,value:a}))}
                    value={time}
                    onChange={handleTime}
                    maxSelectedValues={parseInt(parts,10)}
                    error={isError && time.length < parts ? `Select ${parts - time.length} More Timings`: ""}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <Group position={'center'}>
                    <Button color={'gray'} onClick={onHide}>Cancel</Button>
                    <Button onClick={handleSubmit} loading={isLoading} disabled={data.length < 3 || time.length < parts}>Submit</Button>
                </Group>
            </Grid.Col>
        </Grid>

    </Modal>
}
